export default __webpack_public_path__ + "static/media/btc.34a0ec82.svg";